import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import ErrModalPop from 'components/sales/modal/errorModal';
import parse from 'html-react-parser';
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import DivLayout from 'components/sales/divLayout/divLayout';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DatePicker from "components/sales/datePicker/datePicker";
import { handleValidateObj } from 'constants/objValues/objvalues';
import { toast } from 'react-toastify';
import "./training.css";

const DashboardTraining = ({
  getDashboardTrainingDetails,
  dashboardTraining,
  match,
  location,
  documentUploadUrl,
  postDashboardTrainingData,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [formData, setFormData] = useState(null);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [formField, setFormFields] = useState([]);
  const [completed, setCompleted] = useState('No');
  const [allCompleted,setAllCompleted] = useState('No');
  const [isTrainingComplete, setIsTrainingComplete] = useState('No');
  const [details, setDetails] = useState([]);
  const [addItem, setAddItem] = useState(1);
  const [leadType, setLeadType] = useState('');
  const [isTenant,setIsTenant] = useState('No');
  const [tenantMaster, setTenantMaster] = useState([]);
  const tenants = [
    {tenant_name:'',tenant_email:'',tenantData:[]}
  ];
  const [newTenants, setNewTenants] = useState(tenants);
  const [inputList, setInputList] = useState([
    {
      poc_name: "",
      poc_mail: "",
      poc_phone: "",
      poc_designation: "",
      training_date: "",
    },
  ]);
  const [roles,setRoles] = useState([14,15,16,56]);
  const [roleId,setRoleId] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        if(localStorage.getItem('roles')){
          const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
          setRoleId(roles);
        }
       
      })();
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleInput2Value = (val, key, index) => {
    const list = [...inputList];
    list[index][key] = val;
    setInputList([...list]);
  };

  const handleTenantValues = (val, key, index) => {
    const list = [...newTenants];
    list[index][key] = val;
    setNewTenants([...list]);
  };

  const handleAddClick = () => {
    var size = Object.keys(inputList).length;
    setInputList([
      ...inputList,
      {
        poc_name: "",
        poc_mail: "",
        poc_phone: "",
        poc_designation: "",
        training_date: "",
      },
    ]);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClickTenant = (tenantMaster1) => {
    const list4 = [...newTenants];
    const newArray = tenantMaster1.map(item => ({ ...item, checked: false }));
    list4.push({tenant_name:'',tenant_email:'',tenantData:newArray});
    console.log(list4);
    setNewTenants([...list4]);
  };
  
  // const handleAddClickTenant = (tenantMaster1) => {
  //   console.log('here   ' + JSON.stringify(newTenants));
  //   var size = Object.keys(newTenants).length;
  //   setNewTenants([
  //     ...newTenants,
  //     {tenant_name:'',tenant_email:'',tenantData:tenantMaster1},
  //   ]);
  // };

  const handleRemoveClickTenant = (index) => {
    const list = [...newTenants];
    list.splice(index, 1);
    setNewTenants(list);
  };

  useEffect(() => {
    if(dashboardTraining !== null && dashboardTraining !== undefined) {
      if(dashboardTraining.lead_type !== undefined) {
        setLeadType(dashboardTraining.lead_type);
      }
      if(dashboardTraining.is_training_completed !== undefined) {
        setIsTrainingComplete(dashboardTraining?.is_training_completed);
      } 
      if(dashboardTraining.training_details !== undefined) {
        setDetails(dashboardTraining.training_details);
      }
      if(dashboardTraining.training_form !== undefined) {
        setFormFields(dashboardTraining.training_form);
      }
      if(dashboardTraining.tenant_form !== undefined) {
        const list = [...newTenants];
        list[0]['tenantData'] = dashboardTraining.tenant_form;
        setNewTenants([...list]);
        setTenantMaster(dashboardTraining.tenant_form);
      }
    }
  },[dashboardTraining]);
  

  const handleCheckBox = (key,index) => {
   const list = [...formField];
   if(list[index]['checked']) {
    list[index]['checked'] = false;
   } else {
    list[index]['checked'] = true;
   }
   setFormFields([...list]);
  }

  const handleCheckBoxTenant = (key,pIndex,cIndex) => {
    const listdatas = [...newTenants];
    //  console.log(key + ' ' + pIndex + ' ' + cIndex + ' ' + JSON.stringify(list[pIndex]['tenantData'][cIndex]));
     
    listdatas[pIndex]['tenantData'][cIndex]['checked'] = key
     console.log(listdatas);
     setNewTenants([...listdatas]);
    //  console.log(listdata);
   }

  // const handleCheckBoxTenant = (key,pIndex,cIndex) => {
  //   const listdatas = [...newTenants];
  //   //  console.log(key + ' ' + pIndex + ' ' + cIndex + ' ' + JSON.stringify(list[pIndex]['tenantData'][cIndex]));
     
  //   newTenants[pIndex]['tenantData'][cIndex]['checked'] = key
  //    console.log(listdatas);
  //    setNewTenants([...listdatas]);
  //   //  console.log(listdata);
  //  }

  useEffect(() => {
    if (getDashboardTrainingDetails !== null) (async () => await getDashboardTrainingDetails(match?.params?.site_id))();
  }, [getDashboardTrainingDetails,match?.params?.site_id]);

  const handleSubmit = async() => {
    let isNotEmpty = true;
    let isError = false;
    let isErrorTenant = false;

    inputList.map((val)=> {
      if(!handleValidateObj(val)) {
        isNotEmpty = false;
        isError = true;
        return false;
      }
    });
    
    if(isTenant === 'Yes') {
      newTenants.map((val)=> {
        if(!handleValidateObj(val)) {
          isNotEmpty = false;
          isErrorTenant = true;
          return false;
        }
      });  
    }

    if(isErrorTenant) {
      toast.error('Tenant details are mendatory.');
      return false;
    }

    if(isError) {
      toast.error('POC details are mendatory.');
      return false;
    }
    if (completed == null || completed == "") {
      setIsFiled(true);
      setIsModal(false);
    } else {
          const payload = {
           'isCompeted':completed,
           'site_id':match.params.site_id,
           'stage_id':match.params.stageId,
           'data':formField,
           'poc_details':inputList,
           'tenantDetails':newTenants,
           'is_tenant':isTenant,
           'all_tenant_Training_done':allCompleted,
           'leadType':leadType
          };

          //  console.log('full_data' + JSON.stringify(payload));
          //  return false;
          setIsLoading(true);
          const res = await postDashboardTrainingData(payload);
          setIsLoading(false);
          if (res === true) { 
            setIsModal(true);
          }
          setIsLoading(false);
    }
  };

  // console.log("data" + JSON.stringify(newTenants));

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`/dashboard/site-stage/${match.params.site_id}/${match.params.leadId}`);
  };
  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  const handleModalHide1 = () => setIsErrorModal(false);
  return (
    <Layout
      title={localization.dashboardTraining}
      // Buttons={(isTrainingComplete === 'No' && roles.includes(roleId)) ? headerBtns : null}
      Buttons={isTrainingComplete === 'No' ? headerBtns : null}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.site_id}/${match.params.leadId}`}
      isLoading={isLoading}
    >
      <div className="container-fluid">
      {isTrainingComplete === 'No' && 
        <div className="panel-card card-details">
          <div className="panel-heading">{`Dashboard Training - Checklist`}</div>
          <div className="panel-body">
              <div className="row">
                {formField && formField.length > 0 ?
                  <>
                  {formField.map((val,index) => {
                    return (
                      <div className='col-md-6' key={index}>
                       <div className='col-md-6'>
                        <span className='checklist-title'>{val['key']}</span>
                       </div>
                       <div className='col-md-6'>
                        <input className='checklist-checkbox' type="checkbox" name={val['key']} checked={val['checked']} onClick={() => handleCheckBox(val['key'],index)} />
                       </div>
                      </div>
                    )
                  })}
                  </>
                : null}
             </div>
             <div className='line'></div>
             {/* POC Form */}
             <div className="panel-card card-details">
             <div className="panel-heading">{`Poc Details`}</div>
             <div className="panel-body">
             <div className="row">
             {addItem === 1 ? (
                  <>
                    {inputList.map((x, i) => {
                      return (
                        <div className="" key={{ i }}>
                            <div className="col-md-6 col-sm-12">
                              <ConstantInput
                                label={`Name`}
                                type="email"
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(val) => {
                                  handleInput2Value(val, "poc_name", i);
                                }}
                              />
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <ConstantInput
                                label={`Email`}
                                type="email"
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(val) => {
                                  handleInput2Value(val, "poc_mail", i);
                                }}
                              />
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <ConstantInput
                                label={`Contact No.`}
                                type="number"
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(val) => {
                                  handleInput2Value(val, "poc_phone", i);
                                }}
                              />
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <ConstantInput
                                label={`Designation`}
                                type="email"
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(val) => {
                                  handleInput2Value(val, "poc_designation", i);
                                }}
                              />
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <DatePicker
                                handleChange={(val) =>
                                  handleInput2Value(val, "training_date", i)
                                }
                                label={`Training Date`}
                                required={false}
                                value={x?.training_date}
                              />
                            </div>
                            <div className="col-md-12 col-sm-12 d-flex">
                              {inputList.length !== 1 && (
                                <div className="col-md-2 col-sm-5">
                                  <button
                                    onClick={() => handleRemoveClick(i)}
                                    className="mr10 btn btn-sm btn-danger"
                                  >
                                    Remove
                                  </button>
                                </div>
                              )}
                              {inputList.length - 1 === i && (
                                <div className="col-md-2 col-sm-5">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleAddClick}
                                  >
                                    Add
                                  </button>
                                </div>
                              )}
                            </div>

                          <div className='line2'></div>
                        </div>
                      );
                    })}
                  </>
                ) : addItem === 2 ? (
                  {}
                ) : null}
             </div>
             </div>
            </div>
             {/* POC End */}
             <div className='line'></div>
             <div className="row">
             {leadType !== '' && (leadType === 1 || leadType === 4) ? 
             <>
             <div className='col-md-6'>
              <DropDownInput
                  name="is_tenant"
                  data={[
                    {
                      name: "Yes",
                      id: "Yes",
                    },
                    {
                      name: "No",
                      id: "No",
                    }
                  ]}
                  label={`Is tenant?`}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => setIsTenant(val.id)}
                  value={isTenant}
                />
              </div>
                {isTenant === 'Yes' ?
                <div className="panel-card card-details w-100per">
                 <div className="panel-heading">{`Tenant`}</div>
                  <div className="panel-body">
                    {newTenants.map((val2,index2) => {
                    return (
                     <>
                     <div className="col-md-6 col-sm-12" key={index2}>
                        <ConstantInput
                          label={`Tenant Name`}
                          type="text"
                          required={true}
                          isStarRequired={true}
                          errorMsg={localization.isRequired}
                          handleChange={(val) => {
                            handleTenantValues(val, "tenant_name", index2);
                          }}
                        />
                     </div>
                     <div className="col-md-6 col-sm-12">
                        <ConstantInput
                          label={`Tenant Email`}
                          type="email"
                          required={true}
                          isStarRequired={true}
                          errorMsg={localization.isRequired}
                          handleChange={(val) => {
                            handleTenantValues(val, "tenant_email", index2);
                          }}
                        />
                     </div>
                     {/* {console.log('the data ' + JSON.stringify(val2))} */}
                     {val2?.tenantData !== undefined && val2?.tenantData?.map((val3,index3) => {
                        return (
                          <div className='col-md-6' key={index3}>
                          <div className='col-md-6'>
                            <span className='checklist-title'>{val3['key']}</span>
                          </div>
                          <div className='col-md-6'>
                            <input className='checklist-checkbox' type="checkbox" name={val3['key']} onClick={(e) => handleCheckBoxTenant(e.target.checked,index2,index3)} checked={val3['checked']} />
                          </div>
                          </div>
                        )
                      })}
                      <div className="col-md-12 col-sm-12 d-flex">
                          {newTenants.length !== 1 && (
                            <div className="col-md-2 col-sm-5">
                              <button
                                onClick={() => handleRemoveClickTenant(index2)}
                                className="mr10 btn btn-sm btn-danger"
                              >
                                Remove
                              </button>
                            </div>
                          )}
                          {newTenants.length - 1 === index2 && (
                            <div className="col-md-2 col-sm-5">
                              <button
                                className="btn btn-sm btn-primary"
                                onClick={() => handleAddClickTenant(tenantMaster)}
                              >
                                Add
                              </button>
                            </div>
                          )}
                       </div>
                       <div className='line2'></div>
                     </>
                     )
                    })}
                    </div>
                  </div>
                : null}
             <div className='col-md-6'> 
              {/* <DropDownInput
                  name="category"
                  data={[
                    {
                      name: "Yes",
                      id: "Yes",
                    },
                    {
                      name: "No",
                      id: "No",
                    }
                  ]}
                  label={`All tenants training completed`}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => setAllCompleted(val.id)}
                  value={allCompleted}
                /> */}
              </div>
              </>
             : 
             <div className='col-md-6'>
              {/* <DropDownInput
                  name="category"
                  data={[
                    {
                      name: "Yes",
                      id: "Yes",
                    },
                    {
                      name: "No",
                      id: "No",
                    }
                  ]}
                  label={`Dashboard Training Completed`}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => setCompleted(val.id)}
                  value={completed}
                /> */}
              </div>
              }
             </div>
          </div>
        </div>
      }  
      
      {details && details?.length > 0 && details.map((v,i) => {
        return (
        <div className="panel-card card-details">
          <div className="panel-heading">{`Dashboard Training ${i+1}`}</div>
          <div className="panel-body"> 
              <div className="row">
                {v.details && v.details.map((value,indexKey) => {
                return (
                  <div className='col-md-6' key={indexKey}>
                  <div className='col-md-6'>
                  <span className='checklist-title'>{value['key']}</span>
                  </div>
                  <div className='col-md-6'>
                   <p className="view-icon">
                    {(value['checked']) ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" className="checklist-view bi bi-check-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="checklist-view bi bi-x-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/></svg>}
                   </p>
                  </div>
                  </div>
                  )
                })}
             </div>
             {v.poc_details && v.poc_details.map((poc,pocIndex) => {
              return (
              <div className="panel-card card-details">
                <div className="panel-heading">{`POC ${pocIndex+1}`}</div>
                <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                      heading={'Name'}
                      data={poc?.poc_name}
                  />
                  <DivLayout
                      heading={'Email'}
                      data={poc?.poc_mail}
                  />
                  <DivLayout
                      heading={'Phone'}
                      data={poc?.poc_phone}
                  />
                  <DivLayout
                      heading={'Designation'}
                      data={poc?.poc_designation}
                  />
                  <DivLayout
                      heading={'Training Date'}
                      data={poc?.training_date}
                  />
                </div>  
                </div>
              </div>
              )
             })}

             {/* Tenant Details */}
             {v?.tenant_details !== null && v?.tenant_details !== undefined && v?.tenant_details.map((tenantRaw,tenantIndex) => {
              return (
              <div className="panel-card card-details">
                <div className="panel-heading">{`Tenant ${tenantIndex+1}`}</div>
                <div className="panel-body">
                <div className="details-listing">
                  <DivLayout
                      heading={'Name'}
                      data={tenantRaw?.tenant_name}
                  />
                  <DivLayout
                      heading={'Email'}
                      data={tenantRaw?.tenant_email}
                  />
                </div>
                <div className='line'></div>
                {tenantRaw?.tenantData && tenantRaw?.tenantData?.length > 0 && 
                <div className="row">
                {tenantRaw?.tenantData.map((td,ti) => {
                  return (
                  <div className='col-md-6' key={ti}>
                  <div className='col-md-6'>
                  <span className='checklist-title'>{td['key']}</span>
                  </div>
                  <div className='col-md-6'>
                   <p className="view-icon">
                    {(td['checked']) ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="green" className="checklist-view bi bi-check-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="checklist-view bi bi-x-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/></svg>}
                   </p>
                  </div>
                  </div>
                  )
                })}  
                </div>
                }
                </div>
              </div>
              )
             })}

          </div>
             
          <div className='line'></div>
          <div className="details-listing col-md-12">
             <div className='col-md-6'>
                <DivLayout
                    heading={'Created By'}
                    data={v?.action_created_by}
                />
              </div>
              <div className='col-md-6'>
              <DivLayout
                    heading={'Created On'}
                    data={v?.created_at}
                />
              </div>
           </div>  
        </div>
        )
        })}
      </div>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/site-stage/${match.params.site_id}/${match.params.leadId}`}
            className="btn btn-primary mb-4"
          >
            {`Back To Stages.`}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};
export default DashboardTraining;
